import React, { useEffect, useState, useCallback, useMemo } from "react";
import axios from "axios";
import DataTable from "react-data-table-component";

import { Link } from "react-router-dom";
import config from "../../../config/config";
import Loader from "../../../components/Loader/Loader";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import { Calendar } from "../../../common/imagePath";
import ReactDatetime from "react-datetime";
import moment from "moment";

const SearchSale = (props) => {
  let selectData = [];
  const token = localStorage.getItem("Token");
  const [perPageSize, setperPageSize] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  // const [selectedData, setSelectedData] = useState([]);
  const [sortingId, setSortingId] = useState(1);
  const [sortingDirection, setSortingDirection] = useState("asc");
  const [searchtext, setSearchText] = useState("");
  const [loading, setLoading] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [toggleCleared, setToggleCleared] = useState(false);
  const [data, setData] = useState();
  const [selectedSalesCheckboxIds, setselectedSalesCheckboxIds] = useState("");
  const [location, setLocations] = useState([]);
  let [selectedLocationItems, setSelectedLocationItems] = useState([]);
  const [check, setCheck] = useState([]); // for loactions checkbox
  const [startingDate, setStartingDate] = useState(moment().format("YYYY-MM-DD"));
  const [endingDate, setEndingDate] = useState(moment().format("YYYY-MM-DD"));

  const handleRowSelected = (e) => {
    if (e.selectedRows.length > 0) {
      setSelectedRows(e.selectedRows.map((x) => x.ID));
      selectData[currentPage] = e.selectedRows.map((x) => x.ID);
      console.log(e.selectedRows.map((x) => x.ID));

      const selectedSalesCheckboxIds =
        selectData.length > 0 ? selectData[currentPage].toString() : "";
      setselectedSalesCheckboxIds(selectedSalesCheckboxIds);
      console.log(selectedSalesCheckboxIds);
    }
  };

  // Get all tag data
  const handleListData = (
    locationid,
    enddate,
    startdate,
    searchbox
  ) => {
    setLoading(true);
    axios
      .get(
        `${config.salesconfigBaseUrl}/sales/searchsalelist?startdate=${startdate}&enddate=${enddate}&searchbox=${searchbox}&locationid=${locationid}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log(res.data.ResponseData);
        setData(res.data.ResponseData);
        setTotalRows(res.data.ResponseData[0]?.TotalRecord);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };
  var isCheck = (item) =>
    check.includes(item.Id) ? "checked-item" : "not-checked-item";

  const handleCheck = (event) => {
    const updatedList = check;

    // console.log(event.target.value);
    if (event.target.checked) {
      updatedList.push(event.target.value);
    } else {
      updatedList.splice(check.indexOf(event.target.value), 1);
    }

    console.log(updatedList);
  };

  useEffect(() => {
    handleListData(1);
    axios
      .get(`${config.priceRulesBaseUrl}/pricerules/locationdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setLoading(false);
        setLocations(res.data.ResponseData);
      })
      .catch((err) => {
        setLoading(false);
      });
  }, []);

  const handlestartingDate = (momentDate) => {
    setStartingDate(moment(momentDate).format("YYYY-MM-DD"));
    handleListData(1, endingDate, startingDate, '')
  };

  const handleEndingDate = (momentDate) => {
    setEndingDate(moment(momentDate).format("YYYY-MM-DD"));
    handleListData(1, endingDate, startingDate, '')
  };

  const contextActions = useMemo(() => {
    const handleDeletePopup = () => {
      const deleteRequestParam = {
        deliveriesids: selectedSalesCheckboxIds,
      };
      localStorage.setItem(
        "DeleteRequestParam",
        JSON.stringify(deleteRequestParam)
      );
    };

    return (
      <button
        type="button"
        className="btn btn-success btn-sm pull-left "
        data-bs-toggle="modal"
        data-bs-target="#UnDeleteConfirmationModal"
        onClick={handleDeletePopup}
      >
        <i className="fa fa-trash fa-sm" /> Un Delete
      </button>
    );
  }, [data, selectedRows, toggleCleared]);

  // Table Data
  const columns = [
    {
      name: "Sale ID",
      selector: "ID",
      sortable: true,
    },
    {
      name: "Date",
      selector: "Saletime",
      sortable: true,
    },
    {
      name: "Register",
      selector: "Register",
      sortable: true,
    },
    {
      name: "Items Purchased",
      selector: "Quantitypurchased",
      sortable: true,
    },
    {
      name: "Sold By",
      selector: "soldby",
      sortable: true,
    },
    {
      name: "Sold To",
      selector: "soldto",
      sortable: true,
    },
    {
      name: "Subtotal",
      selector: "Subtotal",
      sortable: true,
    },
    {
      name: "Total",
      selector: "Total",
      sortable: true,
    },
    {
      name: "Tax",
      selector: "Tax",
      sortable: true,
    },
    {
      name: "Profit",
      selector: "Profit",
      sortable: true,
    },
    {
      name: "Payment Type",
      selector: "Payment Type",
      sortable: true,
    },
    {
      name: "Comments",
      selector: "Comment",
      sortable: true,
    },

    {
      name: "Discount Reason",
      selector: "Discountreason",
      sortable: true,
    },
  ];


  const handlePerRowsChange = async (page, newPerPage) => {
    setperPageSize(newPerPage);
    setCurrentPage(page);
    handleListData(page, newPerPage, searchtext, sortingId, sortingDirection);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    handleListData(page, perPageSize, searchtext, sortingId, sortingDirection);
  };

  const handleSort = (e, sortingDirection) => {
    setSortingId(e.id);
    setSortingDirection(sortingDirection);
    handleListData(1, perPageSize, searchtext, e.id, sortingDirection);
  };
  const ChangeFilterText = (e) => {
    setSearchText(e.target.value);
    setCurrentPage(1);
    handleListData(1, perPageSize, e.target.value, sortingId, sortingDirection);
    console.log(handleListData);
  };
  const rowSelectCritera = row => row.fat > 6;

  const clickHandler = (e) => {
    console.log(e.target.id);
  }
  return (
    <>

      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="page-title">
              <h3>Search Sales</h3>
              <ul className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/sales">Sales </Link>
                </li>
                <li className="breadcrumb-item active">Search Sales</li>
              </ul>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-6">
              <div className="form-group row">
                <label className="col-form-label col-md-3 form-label">
                  Starting Date
                </label>
                <div className="col-lg-9">
                  <div className="input-group">
                    <span className="input-group-text" id="basic-addon1">
                      <img src={Calendar} alt="img" />
                    </span>
                    <div style={{ width: "100%" }}>
                      <ReactDatetime
                        value={startingDate}
                        onChange={handlestartingDate}
                        id="StartingDate"
                        name="StartingDate"
                        dateFormat="YYYY-MM-DD"
                        timeFormat={false}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-6">
              <div className="form-group row">
                <label className="col-form-label col-md-3 form-label">
                  Ending Date
                </label>
                <div className="col-lg-9">
                  <div className="input-group">
                    <span className="input-group-text" id="basic-addon1">
                      <img src={Calendar} alt="img" />
                    </span>
                    <div style={{ width: "100%" }}>
                      <ReactDatetime
                        value={endingDate}
                        onChange={handleEndingDate}
                        id="EndingDate"
                        name="EndingDate"
                        dateFormat="YYYY-MM-DD"
                        timeFormat={false}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-12">
              <div className="form-group row">
                <label className="col-form-label col-md-2 form-label">
                  Locations
                </label>
                <div className="col-sm-9 col-md-3 mr-2 pt-2 col-lg-10">
                  <div className="form-check form-check-inline mb-1">
                    {location.map((item) => {

                      return (
                        <div key={item.Id} >
                          <input
                            className="form-check-input me-3"
                            style={{
                              width: "1.25em",
                              height: "1.25em",
                            }}
                            name="Locations"
                            type="checkbox"
                            defaultChecked={
                              selectedLocationItems?.indexOf(
                                item.Id.toString()
                              ) > -1
                                ? // selectedLocationItems?.includes(item.Id.toString())
                                true
                                : false
                            }
                            onChange={(event) => {
                              handleCheck(event);
                            }}
                            value={item.Id}
                          />
                          <label className={isCheck(item.Id)}>
                            {item.Name}
                          </label>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row flex-row-reverse">
            <div className="col-lg-3 col-md-6 col-sm-12 mb-2">
              <input
                type="search"
                placeholder="Search..."
                className="search-btn form-control form-control-sm w-50 pull-right"
                onChange={ChangeFilterText}
                value={searchtext}
              />
              {/* <Input.Search placeholder="Search..." className="search-btn form-control form-control-sm" onChange={ChangeFilterText} /> */}
            </div>
          </div>

          {/* Customer list */}
          <div className="card">
            <div className="card-body">
              <div className="table-responsive">
                <DataTable
                  title="Search Sales "
                  columns={columns}
                  data={data}
                  progressPending={loading}
                  pagination
                  paginationServer
                  paginationTotalRows={totalRows}
                  paginationDefaultPage={currentPage}
                  onChangeRowsPerPage={(e) => {
                    handlePerRowsChange(1, e);
                  }}
                  onChangePage={handlePageChange}
                  highlightOnHover
                  striped
                  responsive
                  paginationRowsPerPageOptions={[10, 25, 50, 100, 500]}
                  persistTableHead
                  selectableRows
                  sortServer
                  onSort={handleSort}
                  contextActions={contextActions}
                  onSelectedRowsChange={handleRowSelected}
                  clearSelectedRows={toggleCleared}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SearchSale;
